import React from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../../i18n/constants/keys';
import { Button } from '../../../../../../../ui';
import { EyeIcons } from '../../../../../../../icons/icons';

interface HeaderCardProps {
  onPreviewClick: () => void;
  onImportClick: () => void;
  isImported: boolean;
}

export const HeaderCard = ({
  onPreviewClick,
  onImportClick,
  isImported,
}: HeaderCardProps) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <div className='rounded-xl border border-slate-200 bg-white p-4 shadow-sm'>
      <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
        <div>
          <h3 className='text-sm font-extrabold text-slate-900'>
            {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.roleDetails)}
          </h3>
        </div>
        <div className='flex flex-wrap items-center gap-2'>
          <Button
            onClick={onPreviewClick}
            variant='secondary'
            label={t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.publicFacingPreview)}
            className='w-full sm:w-auto font-semibold'
            icon={<EyeIcons className='w-5 h-5' />}
            hasIcon
          />
          <Button
            onClick={onImportClick}
            variant={isImported ? 'secondary' : 'primary'}
            label={
              isImported
                ? t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.undoImports)
                : t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.details.importFromJD)
            }
            className='w-full sm:w-auto font-semibold'
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderCard;
